import './coupon_input.css';
import { useEffect, useRef, useState } from 'react';
import { PlusIcon } from '../../assets/icons/PlusIcon';
import { SpinnerLoader } from '../SpinnerLoader/SpinnerLoader';
import { CouponIcon } from '../../assets/icons/CouponIcon';
import { useCart } from '../../context/CartContext';
import { useServer } from '../../context/ServerContext';
import { couponsEndpoints } from '../../env';

export const CouponInput = () => {
    //HOOKS
    const { cart, loadCart } = useCart();
    const { postRequest } = useServer();

    //REFS
    const couponContainerRef = useRef(null);
    const successRef = useRef(null);

    //STATES
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    //FUNCTIONS
    const applyCoupon = () => {
        if (loading) return;
        if (code === "") {
            setErrorMsg("Please enter a coupon code");
            return;
        }

        setLoading(true);
        setErrorMsg("");
        successRef.current.classList.remove('active');

        const data = {
            cart_token: cart.token,
            code,
        }

        postRequest(couponsEndpoints.apply, data, ([status, res]) => {
            setLoading(false);
            if (status)
            {
                if (res.success)
                {
                    successRef.current.classList.add('active');
                    loadCart();
                }
                else
                {
                    switch (res.error_code) {
                        case "coupon_not_exist":
                            setErrorMsg("This coupon code does not exist");
                            break;
                        case "coupon_min_order_not_reached":
                            setErrorMsg("The minimun order for this coupon is $" + res.min / 100);
                            break;
                        case "coupon_not_active":
                            setErrorMsg("The coupon is currently unavailable");
                            break;
                        default:
                            setErrorMsg("Something went wrong, please try again in a bit");
                            break;
                    }
                }
            }
            else
            {
                setErrorMsg("Server error, please try again later");
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        if (cart && cart.discounts.coupon)
        {
            setCode(cart.discounts.coupon.code);

            if (couponContainerRef.current)
            {
                couponContainerRef.current.classList.toggle('active')
            }
        }
    }, [cart, couponContainerRef]);

    return (
        <div className='coupon_container' ref={couponContainerRef}>
            <div className='title' onClick={() => couponContainerRef.current.classList.toggle('active')}>
                <CouponIcon />
                <h2>
                    Have a coupon code?
                </h2>
                <button>
                    <PlusIcon />
                </button>
            </div>
            <div className='loader active'>
                {
                    loading && <SpinnerLoader />
                }
            </div>
            <div className='coupon_input_container'>
                <input type="text" placeholder='Your coupon here!' value={code} onChange={(e) => setCode(e.target.value)} />
                <button onClick={applyCoupon} disabled={loading}>
                    Add
                </button>
                <label className='error_msg active'>
                    {errorMsg}
                </label>
                <label className='error_msg success' ref={successRef}>
                    Coupon added
                </label>
            </div>
        </div>
    );
}